import { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { api } from "../../lib/api";
import { type User, useAuthStore } from "../../lib/auth-store";

interface Props {
  children: React.ReactNode;
}

/**
 * Gate per le pagine che richiedono autenticazione.
 * Se non loggato → redirect a /login mantenendo la destinazione richiesta come state.
 */
// Pagine aperte anche a chi non fa ancora parte di nessuna lega.
const SENZA_LEGA_OK = ["/leghe", "/profilo", "/accetta-invito"];

export function ProtectedRoute({ children }: Props) {
  const accessToken = useAuthStore((s) => s.accessToken);
  const user = useAuthStore((s) => s.user);
  const setUser = useAuthStore((s) => s.setUser);
  const clear = useAuthStore((s) => s.clear);
  const location = useLocation();
  // Bootstrap (2026-10-09): il profilo non e' persistito; aprendo una pagina
  // direttamente (ricarica, link) lo carichiamo qui, per TUTTE le pagine
  // protette. Prima lo facevano solo le pagine che usano useAuth(): /profilo
  // ricaricata restava vuota.
  useEffect(() => {
    if (!accessToken || user) return;
    api
      .get<User>("/auth/me")
      .then((res) => setUser(res.data))
      .catch(() => clear());
  }, [accessToken, user, setUser, clear]);
  if (!accessToken) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  // Andrea 2026-10-06: chi si e' registrato per creare una lega (o e' uscito
  // da tutte) resta su /leghe finche' non ne crea una o entra con un codice:
  // senza, il server gli mostrerebbe la lega di default.
  if (
    user &&
    user.n_leghe === 0 &&
    !user.is_admin_app &&
    !SENZA_LEGA_OK.includes(location.pathname)
  ) {
    return <Navigate to="/leghe" replace />;
  }
  return <>{children}</>;
}
